// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.inventory.item.CreateItemQuantityChangePurchaseOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateItemQuantityChangePurchaseOrderRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfValidator({ notNull: { message: 'Practice location item is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationProductItemId!: number;

	@GandalfValidator({ notNull: { message: 'Practice location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationId!: number;

	@GandalfValidator({ notNull: { message: 'Quantity change is required' } })
	@GandalfValidator({ min: { min: 0, message: '# Received can not be less than 0' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	quantityChange!: number;

	@GandalfValidator({ notNull: { message: 'Unit cost is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	unitCost!: number;

}
